import Component from '../abstracts/Component';
import {CURRENT_LANG, IS_MOBILE} from "../utils/Environment";

const CHAT_FORM_ID = "#chatForm";

const chatBasicConf = {
  "mode": "inner", //Button to open window display mode
  "language": !CURRENT_LANG || 'zh-cn',
  "pos_flag":"hlb",
  "color":"white",
  "noBubble":true,
  //"onlineText": "联系客服，在线咨询",
  //"offlineText": "客服下班，请留言",
  //"manualInit": true, //Manual initialization; the embedded code won't be initialized automatically and ud('init') method has to be called
  'targetSelector': '#udesk_btn',
  'css':{
    'bottom': '15px',
    'border-radius': '20px',
    'padding': '0px',
    'width': 'fit-content',
    'min-width': '80px',
    'left': '20px'
  },
  "mobile": {
    "pos_flag":"hlb",
    "color":"white",
    "noBubble":true,
    "mode": "blank",
    //"onlineText": "联系客服，在线咨询",
    //"offlineText": "客服下班，请留言"
    'css':{
      'bottom': '70px',
      'width': 'fit-content',
      'min-width': '80px',
      'border-radius': '20px',
      'padding': '0px',
      'left': '20px'
    },
  },
  "panel": {
    "css": {
      "left": "60px",
      "bottom": "30px"
    }
  }
};

if(IS_MOBILE){
  chatBasicConf.panel.css={
    height: "100%",
    wight: "100%",
    left: "0px",
    right: "0px",
    bottom: "0px",
    top: "0px"
  }
}

/**
 Chat component
 */
export default class ChatComponentChina extends Component {


  get SELECTORS() {
    return {
      onlineButton: '.onlineButton', // bottone non flottante che indica stato "online" della chat
      offlineButton: '.offlineButton', // bottone non flottante che indica stato "offline" della chat
      automatedButton: '.live-chat-btn', // bottone flottante per ingaggio chat
      chatInitialized: '.chat-container.initialized', // div contenitore dell'iframe della chat, indicazione che e' stato inizializzato
      chatIframe: '#chat_iframe', // iframe con la chat salesforce
      chatStatus: '.js-chat-status',
      chatHours: '.js-chat-hours',
      ctaStartChat: '.cta-chat button',
      chatCta: '.chat-cta',
      liveChatCta: '.live-chat-cta',
      chatContainer: '#udesk_container'
    }
  }

  get CLASSES() {
    return {
      chatOnline: 'online'
    }
  }

  get VARIABLES() {
    return {
      // mapping con configurazioni della chat che arrivano da backoffice (proprieta' del CMSSite, "chatConfiguration")
      // vengono presi da elFunctionsBean e inseriti tramite chat-javascript.tag
      companyClientLink: $('#urlEnvironmentSF').attr("value"),
      companyId: $('#chatOrgId').attr("value")
    }
  }

  constructor() {
    super();
  }

  /**
   * Inizializzazione della live chat nella pagina di live chat
   */
  initializeChat() {

  }

  initChatSnapIns() {

    $('body').on('click', '.headerText', {component: this}, function (event) {
      event.preventDefault();
      $('.minimizeButton.headerItem').trigger('click');
    });

    let automatedButton = this.SELECTORS.automatedButton;
    let $chatStatus = $(this.SELECTORS.chatStatus);
    let chatOnline = this.CLASSES.chatOnline;
    let chatCta = this.SELECTORS.chatCta;
    $(automatedButton).removeClass("d-none");
    $chatStatus.addClass(chatOnline);
    $(chatCta).removeClass('not-available');
    $('.js-open-chatLayer').removeClass('not-available');

    let ctx = this;
    $('body').on('change', '#chatForm .js-subject', function () {
      if ($("[name*='subject']").val() != null) {
        $("#chatForm select[name*='subject']").removeClass('error');
      }
    });
    $('body').on('click', this.SELECTORS.ctaStartChat, {component: this}, function (event) {
      event.preventDefault();
      let motivo_di_contatto__c = $(`${CHAT_FORM_ID} select[name*='subject']`).val();
      //$('#udesk_container').removeClass("d-none");
      ctx.validateUserDataThenOpenChat(CHAT_FORM_ID, motivo_di_contatto__c, false, ctx);
    });

  }

  validateUserDataThenOpenChat(userDataContainerSelector, motivo_di_contatto__c, wasTriggeredByPersonalStylistPopUp, ctx) {

    const $firstNameSelector = $(`${userDataContainerSelector} input[name*='name']`);
    const $lastNameSelector = $(`${userDataContainerSelector} input[name*='surname']`);
    const $emailSelector = $(`${userDataContainerSelector} input[name*='email']`);


    let firstName = $firstNameSelector.val();
    let lastName = $lastNameSelector.val();
    let email = $emailSelector.val()

    const pattern = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;

    /**
     * Form validation
     */
    if (firstName != null && lastName != null && pattern.test(email) && motivo_di_contatto__c != null) {
      $('.warning').addClass('d-none');
    } else {
      $('.warning').removeClass('d-none');
      if (firstName == null || firstName == '') {
        $firstNameSelector.addClass('error');
      }
      if (lastName == null || lastName == '') {
        $lastNameSelector.addClass('error');
      }
      if (email == null || email == '') {
        $emailSelector.addClass('error');
      }
      if (motivo_di_contatto__c == null) {
        $(`#chatForm select[name*='subject']`).addClass('error');
      }
      return;
    }

    ctx.startChatInitSnapins(firstName, lastName, email, motivo_di_contatto__c, ctx.VARIABLES.companyId, ctx.VARIABLES.companyClientLink);
  }

  startChatInitSnapins(firstName, lastName, email, motivo_di_contatto__c, companyId, companyClientLink) {


    const configurations = {
      "code": companyId,
      "link": companyClientLink,
      "ticket": {
        "t_subject": motivo_di_contatto__c
      }
    };

    if (email) {
      $.get(`/action/chat-session-key?operation=generate&email=${email}`,{
        xhrFields: {
          withCredentials: true
        },
      }).then(res=> {
        $.get(`/action/chat-signature?webToken=${email}`).then(res2 => {
          $(this.SELECTORS.liveChatCta).addClass("d-none");
          configurations.customer = {
            "c_name": firstName + " " + lastName
          }
          Object.assign(configurations.customer,res2)
          Object.assign(configurations,res,chatBasicConf);
          $('.vex-close').trigger('click')
          ud(
            configurations
          );
          ud("init")
          $('#udesk_btn').trigger('click')
        });
      });
    }

  }

  render() {

    // caricamento javascript salesforce e successiva inizializzazione eventi js

    const chatEnabled = $('#lightningChat').val() == 'true';
    if (chatEnabled) {

      $.get(`/action/chat-session-key`,{
        xhrFields: {
          withCredentials: true
        },
      }).then(res=>{
          (function(a,h,c,b,f,g){a["UdeskApiObject"]=f;a[f]=a[f]||function(){(a[f].d=a[f].d||[]).push(arguments)};g=h.createElement(c);g.async=1;g.charset="utf-8";g.src=b;c=h.getElementsByTagName(c)[0];c.parentNode.insertBefore(g,c)})(window,document,"script","https://assets-cli.udesk.cn/im_client/js/udeskApi.js","ud");

          window.addEventListener('message',(event)=> {
            let receiveEvent = JSON.parse(event.data)
            if (receiveEvent.type === 'chatDone') {
              $(this.SELECTORS.chatContainer).addClass("d-none");
              $(this.SELECTORS.liveChatCta).removeClass("d-none");
              $.get(`/action/chat-session-key?operation=close`,{
                xhrFields: {
                  withCredentials: true
                },
              })
            }
          })

          this.initChatSnapIns();

          if(res.session_key){
            $(this.SELECTORS.liveChatCta).addClass("d-none");
            const conf = Object.assign(
              {
                "code": this.VARIABLES.companyId,
                "link": this.VARIABLES.companyClientLink
              },
              chatBasicConf
            );
            conf.customer=res;
            ud(
              conf
            );
          }else {
            ud({
              "code": this.VARIABLES.companyId,
              "link": this.VARIABLES.companyClientLink,
              "manualInit":true
            });
          }
      });

    }
  }

}
